import React from 'react'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import LABEL from '../../../business-const/Label/Label'

import {
    ChartPadraoPie,
} from '../../../business-components/Chart/Chart'



const AnalisePatrimonialPieChart = ( { estudo, report, simulacaoFinanceira, valorCSVidaInteira,
    valorPremioAnualizadoVidaInteira } ) => {

    const AnalisePatrimonialPie = () => {

        const seriesPie = []
        const paletaCoresEspecificaPie = []
        const categoriesPie = []

        if (estudo.current.valorPatrimonioImobilizadoDetalhadoBensMoveisImoveis > 0) {

            seriesPie.push(
                estudo.current.valorPatrimonioImobilizadoDetalhadoBensMoveisImoveis
            )
            
            paletaCoresEspecificaPie.push(
                COLOR().corChartPadraoAnalisePatrimonialAtivosPatrimonioImobilizadoBensMoveisImoveis
            )

            categoriesPie.push(
                LABEL.patrimonioImobilizadoBensMoveisImoveis
            )
        }

        if (estudo.current.valorPatrimonioImobilizadoDetalhadoNegocios > 0) {

            seriesPie.push(
                estudo.current.valorPatrimonioImobilizadoDetalhadoNegocios
            )
            
            paletaCoresEspecificaPie.push(
                COLOR().corChartPadraoAnalisePatrimonialAtivosPatrimonioImobilizadoNegocios
            )

            categoriesPie.push(
                LABEL.patrimonioImobilizadoNegocios
            )
        }

        const valorRecursosFinanceirosDetalhado = estudo.current.valorRecursosFinanceirosDetalhado -
            (valorPremioAnualizadoVidaInteira ? valorPremioAnualizadoVidaInteira : 0)

        if (valorRecursosFinanceirosDetalhado > 0) {

            seriesPie.push(
                valorRecursosFinanceirosDetalhado
            )
            
            paletaCoresEspecificaPie.push(
                COLOR().corChartPadraoAnalisePatrimonialAtivosRecursosFinanceiros
            )

            categoriesPie.push(
                LABEL.recursosFinanceiros
            )
        }

        if (valorCSVidaInteira > 0) {

            seriesPie.push(
                valorCSVidaInteira
            )
            
            paletaCoresEspecificaPie.push(
                COLOR().corChartPadraoVidaInteiraCotacao
            )

            categoriesPie.push(
                LABEL.vidaInteira
            )
        }



        return (
            <ChartPadraoPie
                series={seriesPie}
                width={report ? 420 : simulacaoFinanceira ? 380 : 480}////{report ? 320 : simulacaoFinanceira ? 280 : 360}
                height={report ? 420 : simulacaoFinanceira ? 380 : 480}////{report ? 320 : simulacaoFinanceira ? 280 : 360}
                labels={categoriesPie}
                //fillOpacity={0.9}
                fillType='gradient'
                ////fillShadeIntensity={0.3}
                paletaCores={paletaCoresEspecificaPie}
                ////dataLabelsColor={COLOR().corChartPadraoAnalisePatrimonialLegendaGraficoPizza}
                labelsSomentePerc={false}
                totalSeries={
                    estudo.current.valorPatrimonioImobilizadoDetalhadoBensMoveisImoveis +
                    estudo.current.valorPatrimonioImobilizadoDetalhadoNegocios +
                    estudo.current.valorRecursosFinanceirosDetalhado +
                    (valorCSVidaInteira ? valorCSVidaInteira : 0)
                }
            />
        )
    }

    return (
        <AnalisePatrimonialPie/>
    )
}

export default AnalisePatrimonialPieChart